import { Injectable } from '@kaokei/use-vue-service';

import { DaoService } from './dao.service';

import { pad } from '@/utils';

import COS from 'cos-js-sdk-v5';

@Injectable()
export class CosService {
  constructor(public daoService: DaoService) {}

  /**
   * 上传blob数据
   *
   * @param {Blob} blob
   * @param {string} fileName
   * @return {*}
   * @memberof CosService
   */
  public uploadBlob(
    blob: Blob,
    fileName: string,
    cosType = 'video'
  ): Promise<COS.PutObjectResult> {
    return this.daoService.getTempStsKey(cosType).then(config => {
      const client = new COS({
        UseAccelerate: config.userAccelerate || false,
        getAuthorization: (_, callback) => {
          callback({
            TmpSecretId: config.accessKeyId,
            TmpSecretKey: config.accessKeySecret,
            SecurityToken: config.securityToken,
            StartTime: config.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: config.expiredTime, // 时间戳，单位秒，如：1580000900
          });
        },
      });

      const fullFileName = `${config.dir || ''}${fileName}`;
      return new Promise((resolve, reject) => {
        client.putObject(
          {
            Bucket: config.bucketName,
            Region: config.region,
            Key: fullFileName,
            StorageClass: 'MAZ_STANDARD',
            Body: blob,
          },
          (err, data) => {
            if (err) {
              this.reUploadBlob(blob, fileName, cosType)
                .then(res => {
                  resolve(res);
                })
                .catch(err => {
                  reject(err);
                });
            } else {
              resolve(data);
            }
          }
        );
      });
    });
  }

  /**
   * 重新上传一次
   *
   * @param {Blob} blob
   * @param {string} fileName
   * @return {*}
   * @memberof CosService
   */
  public reUploadBlob(
    blob: Blob,
    fileName: string,
    cosType = 'video'
  ): Promise<COS.PutObjectResult> {
    return this.daoService.resetTempStsKey(cosType).then(config => {
      const client = new COS({
        UseAccelerate: config.userAccelerate || false,
        getAuthorization: (_, callback) => {
          callback({
            TmpSecretId: config.accessKeyId,
            TmpSecretKey: config.accessKeySecret,
            SecurityToken: config.securityToken,
            StartTime: config.startTime, // 时间戳，单位秒，如：1580000000
            ExpiredTime: config.expiredTime, // 时间戳，单位秒，如：1580000900
          });
        },
      });

      const fullFileName = `${config.dir || ''}${fileName}`;
      return new Promise((resolve, reject) => {
        client.putObject(
          {
            Bucket: config.bucketName,
            Region: config.region,
            Key: fullFileName,
            StorageClass: 'MAZ_STANDARD',
            Body: blob,
          },
          (err, data) => {
            if (err) {
              reject(err);
            } else {
              resolve(data);
            }
          }
        );
      });
    });
  }

  /**
   * 获取文件名
   * 项目路径+userId+年月日+时间戳+随机值+文件后缀
   *
   * @param {number} userId
   * @param {string} suffix
   * @return {*}
   * @memberof CosService
   */
  public getBlobName(mobile = 'empty', suffix: string) {
    const randomKey = Math.random().toString().slice(2, 12);
    const currentDate = new Date();
    const currentTime = currentDate.getTime();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    return `${mobile}/${year}_${pad(month)}_${pad(
      day
    )}_${currentTime}_${randomKey}_${suffix}`;
  }
}
